<ng-container [ngTemplateOutlet]="placements.length ? offerContainer : emptyState" />

<ng-template #emptyState>
  <span>
    {{ 'app.candidate.not_assigned' | translate }}
  </span>
</ng-template>

<ng-template #offerContainer>
  <rti-select-offer-placement
    [placements]="placements"
    [selectedOfferAndLocationIds]="selectedOfferAndLocationIds"
    (selectedOfferAndLocationIdsUpdated)="selectedOfferAndLocationIdsUpdated($event)"
  />
</ng-template>
